

















































import Vue from 'vue';
import { BRow, BCol, BFormRadioGroup } from 'bootstrap-vue';
import { mapGetters, mapActions } from 'vuex';

import { ZenFormGroup } from 'zenComponents';
import DropdownPresenter from '@/components/presenters/DropdownPresenter.vue';

import { Audit } from '../types';

export default Vue.extend({
  name: 'ASWStep4',
  components: {
    BRow,
    BCol,
    BFormRadioGroup,
    ZenFormGroup,
    DropdownPresenter,
  },
  props: {
    audit: {
      type: Object as () => Audit,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auditSetupWizard', [
      'performingAssessment',
      'getPerformAssessmentOptions',
      'getAssessorOptions',
      'getVerifierOptions',
    ]),
  },
  methods: {
    ...mapActions('auditSetupWizard', ['setPerformingAssessment', 'setAssessors', 'setVerifiers']),
  },
});
